<div class="menu" *ngIf="displayMenuItems">
    <a [routerLink]="'/sessions'" mat-button>
      Sessions
    </a>
    <a [routerLink]="'/events'" mat-button>
      Events
    </a>
    <a [routerLink]="'/audits'" mat-button>
      Audits
    </a>
</div>
